import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import {
  setFlagMobile,
  setIsPopupMobile,
  setMobileResponse,
  setResponseDescriptionMobile,
  setResponseTitleMobile,
} from "../features/appMobileSlice";
import "../../src/utils/Style/component/modals.scss";

const flagIconMap = {
  0: "/Images/check.png",
  1: "/Images/check.png",
  435: "/Images/warning.png",
  436: "/Images/warning.png",
  437: "/Images/warning.png",
};

function ValidationPopupMobile() {
  const [icon, setIcon] = useState("/Images/caution.png");
  const [isOpen, setIsOpen] = useState(false);
  const [approveAllSnapshot, setApproveAllSnapshot] = useState(false);

  const {
    flagMobile,
    responseTitleMobile,
    responseDescriptionMobile,
    isPopupMobile,
    isApproveAll,
    deviceType,
  } = useSelector((state) => state.appData);

  const dispatch = useDispatch();

  useEffect(() => {
    setIsOpen(isPopupMobile);

    if (isPopupMobile) {
      setApproveAllSnapshot(isApproveAll);
    }
  }, [isPopupMobile, isApproveAll]);


  const onClosePopup = () => {
    dispatch(setFlagMobile(null));
    dispatch(setIsPopupMobile(false));
    dispatch(setResponseTitleMobile(null));
    dispatch(setResponseDescriptionMobile(null));
    setIsOpen(false);

    if (approveAllSnapshot) {
      setTimeout(() => {
        if (deviceType === "Android") {
          window.AndroidInterface?.callbackHandler?.("GoToApp");
        } else if (deviceType === "Iphone") {
          window.webkit?.messageHandlers?.callbackHandler?.postMessage(
            "GoToApp"
          );
        }
      }, 300);
    }
  };

  useEffect(() => {
    if (flagMobile !== null) {
      const iconPath = flagIconMap[Number(flagMobile)] || "/Images/caution.png";
      setIcon(iconPath);
    }
  }, [flagMobile]);

  // useEffect(() => {
  //   dispatch(setMobileResponse(""));
  //   window.handleCheckout = (message) => {
  //     dispatch(setMobileResponse(message));
  //   };

  //   if (mobileMessage) {
  //     if (deviceType === "Android") {
  //       window.AndroidInterface.callbackHandler("GoToApp");
  //     } else if (deviceType === "Iphone") {
  //       window.webkit.messageHandlers.callbackHandler.postMessage("GoToApp");
  //     }
  //   }
  // });
  return (
    <>
      {isPopupMobile && (
        <Modal centered show={isOpen} onHide={onClosePopup}>
          <Modal.Body>
            <div className="header">
              <div className="modal-header-image">
                <img src={icon} alt="Icon" />
              </div>
              <div className="cashin-text">{responseTitleMobile}</div>
            </div>
            <div className="response-message">
              <div className="cashin-text">{responseDescriptionMobile}</div>
            </div>
            <div className="centered">
              <button id="closeModalBtn" onClick={onClosePopup}>
                OK
              </button>
            </div>
          </Modal.Body>
        </Modal>
      )}
    </>
  );
}

export default ValidationPopupMobile;
